/** @format */

var AbstractWS = require('./AbstractWS');

function UpdateCustomPropertiesWS(viewModel) {
  var self = this;

  AbstractWS.apply(this, arguments);
  self.name = "UpdateCustomPropertiesWS"

  this.method("POST");

  /**
   * @type  {KnockoutComputed<number>}
   */
  this._locationId = ko.observable(null);

  this.serviceURL = ko.deferredComputed(function () {
    var locationId = self._locationId();
    return "/qless/api/v1/kiosk/location/" + locationId + "/customProps";
  });

  /**
   * @typedef UpdateConsumerRecordParameters
   * @property {string} phone
   * @property {string} locationId
   * @property {string} customProperties
   */

  /**
   * Updates the Custom Properties in the Consumer's permanent record (ConsumerInfo)
   * When the Consumer returns to the Merchant/Location, these properties may be restored.
   *
   * @param {UpdateConsumerRecordParameters} updateParameters
   * @param {function} callback
   */
  self.updateConsumerRecord = function (updateParameters, callback, errorCallback) {
    self.addParams(
      Object.assign(updateParameters.customProperties, {
        phone: updateParameters.phone,
      })
    );
    self._locationId(updateParameters.locationId);
    self.doRequest(callback, errorCallback);
  };

  /**
   * @typedef UpdateConsumerSessionParameters
   * @property {string} sessionId
   * @property {string} locationId
   * @property {string} customProperties
   */

  /**
   * Updates the Custom Properties for the specified session only.
   * @param {UpdateConsumerSessionParameters} updateParameters
   * @param {function} callback
   */
  self.updateConsumerSession = function (updateParameters, callback, errorCallback) {
    self.addParams(
      Object.assign(updateParameters.customProperties, {
        sessionId: updateParameters.sessionId,
      })
    );
    self._locationId(updateParameters.locationId);
    self.doRequest(callback, errorCallback);
  };

  // Override the method to disable appending the timestamp.
  // The API interprets the timestamp as a Custom Property name.
  self.timestampedURL = function () {
    return self.serviceURL()
  }
}

UpdateCustomPropertiesWS.prototype = Object.create(AbstractWS.prototype);
UpdateCustomPropertiesWS.prototype.constructor = UpdateCustomPropertiesWS;

module.exports = UpdateCustomPropertiesWS;
